module.exports = __webpack_public_path__ + "img/Frame 108.ed95820f.png";